export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./events-list.vue?vue&type=template&id=530b52eb&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/events-list/events-list.vue?vue&type=template&id=530b52eb&
// module id = 1172
// module chunks = 0